<div
	adaViewboxDirective
	class="viewbox"
	[adaViewboxGridDirective]="hasBackgroundGrid()"
	[canPan]="canPan()"
	[gridStyles]="backgroundGridStyles()"
	[minZoom]="minZoom()"
	[zoomFactor]="zoomFactor()"
	[(x)]="x"
	[(y)]="y"
	[(z)]="z"
>
	<div
		#ContentWrapper
		class="content-layer"
	>
		<ng-content />
	</div>
	<ng-content select="[ada-viewbox-control]" />
</div>
